/**
 * Focus Session Storage Utilities
 * Manages localStorage persistence for focus session summaries
 */

interface FocusSessionData {
  summary: string;
  messageCount: number;
  focusStartTime: string;
  channelCount: number;
  focusDuration?: string;
  focusMode?: 'focus' | 'deep-work';
  timestamp: string;
}

const STORAGE_KEY = 'cleariest_focus_session_summary';

/**
 * Store a focus session summary in localStorage
 */
export function storeFocusSessionSummary(data: Omit<FocusSessionData, 'timestamp'>) {
  const sessionData: FocusSessionData = {
    ...data,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sessionData));
}

/**
 * Clear the stored focus session summary
 */
export function clearFocusSessionSummary() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Get the stored focus session summary
 */
export function getFocusSessionSummary(): FocusSessionData | null {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return null;
  
  try {
    return JSON.parse(stored) as FocusSessionData;
  } catch (error) {
    console.error('Failed to parse focus session data:', error);
    return null;
  }
}
